import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import lib from '../../../assets/utils/lib';
import { resolvePartnerDetailTabFromSearch } from '../partners/partnerTabUtils';

function unwrapBody(resp) {
  return resp?.data || resp;
}

/** Legacy `/admin/integrations/saaspro` → partner detail via `by-slug/saaspro`. */
export default function SaaSProRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const resp = await lib.getIntegrationPartnerBySlug('saaspro');
        if (cancelled) return;
        const body = unwrapBody(resp);
        if (Number(body?.error) && body?.error !== 0) {
          navigate('/admin/integrations/partners', { replace: true });
          return;
        }
        const data = body?.data ?? body;
        const partner = data?.partner || data;
        const id = partner?.id;
        const { outer, subtab } = resolvePartnerDetailTabFromSearch(location.search);
        const sp = new URLSearchParams();
        sp.set('tab', outer);
        if (outer === 'pa-agent' && subtab) sp.set('subtab', subtab);
        const cid = new URLSearchParams(location.search).get('correlation_id');
        const checkinId = new URLSearchParams(location.search).get('checkin_id');
        if (cid) sp.set('correlation_id', cid);
        if (checkinId) sp.set('checkin_id', checkinId);
        const qs = sp.toString() ? `?${sp.toString()}` : '';

        if (id != null) {
          navigate(`/admin/integrations/partners/${id}${qs}`, { replace: true });
        } else {
          navigate(`/admin/integrations/partners${qs}`, { replace: true });
        }
      } catch {
        if (!cancelled) navigate('/admin/integrations/partners', { replace: true });
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [navigate, location.search]);

  return (
    <div style={{ padding: 48, textAlign: 'center' }}>
      <Spin size="large" />
    </div>
  );
}
